/*
  TotalVet homepage: FAQ accordion (sections/tv-home-faq.liquid).
  Port of the WP homepage's Bootstrap 5 collapse accordion (data-bs-parent="#faqAccordion") plus
  initFAQAccordion() from homepage_v3.js: one item open at a time, height animation 0.35s ease,
  chevron-right when closed / chevron-down when open (driven by aria-expanded in the section CSS).
*/
(() => {
  if (customElements.get('tv-home-faq')) return;

  const DURATION = 350;

  class TvHomeFaq extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const button = event.target.closest('[data-faq-toggle]');
        if (!button || !this.contains(button)) return;
        this.toggle(button.closest('[data-faq-item]'));
      };
      this.onBlockSelect = (event) => {
        const item = event.target.closest('[data-faq-item]');
        if (item && !this.isOpen(item)) this.show(item);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    get items() {
      return Array.from(this.querySelectorAll('[data-faq-item]'));
    }

    parts(item) {
      return {
        button: item.querySelector('[data-faq-toggle]'),
        panel: item.querySelector('[data-faq-panel]'),
      };
    }

    isOpen(item) {
      return this.parts(item).button.getAttribute('aria-expanded') === 'true';
    }

    isBusy() {
      return this.items.some((item) => this.parts(item).panel.classList.contains('is-collapsing'));
    }

    toggle(item) {
      if (!item) return;
      if (this.isOpen(item)) {
        this.hide(item);
      } else {
        this.show(item);
      }
    }

    show(item) {
      if (this.isBusy()) return;
      this.items.forEach((other) => {
        if (other !== item && this.isOpen(other)) this.hide(other);
      });
      const { button, panel } = this.parts(item);
      button.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-collapsing');
      panel.style.height = '0px';
      const target = panel.scrollHeight;
      panel.style.height = `${target}px`;
      this.afterTransition(panel, () => {
        panel.classList.remove('is-collapsing');
        panel.classList.add('is-shown');
        panel.style.height = '';
      });
    }

    hide(item) {
      const { button, panel } = this.parts(item);
      if (panel.classList.contains('is-collapsing')) return;
      button.setAttribute('aria-expanded', 'false');
      panel.style.height = `${panel.getBoundingClientRect().height}px`;
      void panel.offsetHeight;
      panel.classList.add('is-collapsing');
      panel.classList.remove('is-shown');
      panel.style.height = '';
      this.afterTransition(panel, () => {
        panel.classList.remove('is-collapsing');
      });
    }

    afterTransition(panel, callback) {
      let done = false;
      const finish = (event) => {
        if (event && (event.target !== panel || event.propertyName !== 'height')) return;
        if (done) return;
        done = true;
        panel.removeEventListener('transitionend', finish);
        clearTimeout(timer);
        callback();
      };
      const timer = setTimeout(finish, DURATION + 50);
      panel.addEventListener('transitionend', finish);
    }
  }

  customElements.define('tv-home-faq', TvHomeFaq);
})();
